__turbopack_context__.v({
  "channel_logo": "Nd7elG_channel_logo",
  "channel_name": "Nd7elG_channel_name",
  "channel_thumbnail": "Nd7elG_channel_thumbnail",
  "channel_thumbnail_image": "Nd7elG_channel_thumbnail_image",
  "channel_thumbnail_info": "Nd7elG_channel_thumbnail_info",
  "episode_title": "Nd7elG_episode_title",
  "live_badge": "Nd7elG_live_badge",
  "live_indicator": "Nd7elG_live_indicator",
  "no_image_fallback": "Nd7elG_no_image_fallback",
  "show_title": "Nd7elG_show_title",
  "signal_icon": "Nd7elG_signal_icon",
});
